export default {
    name: 'ButtonDelete',
};